import { autoinject } from 'aurelia-framework';
import { json } from 'aurelia-fetch-client';
import { ApiService } from '../../utils/api-service';
import { IText } from '../../utils/translator';

@autoinject
export class AccountGroupService {
	constructor(private api: ApiService) {
	}

	getAccountGroups(): Promise<IAccountClassAM[]> {
		return this.api.fetchJson('account-groups');
	}

	updateAccountGroupOfAccount(accountId: string, accountGroupId: string): Promise<any> {
		return this.api.fetch(
			`accounts/${accountId}/update-account-group`, {
				method: 'post',
				body: json({ accountGroupId })
			});
	}
}

export interface IAccountClassAM {
	name: string;
	accountGroups: IAccountGroupAM[];
}

export interface IAccountGroupAM {
	id: string;
	nameText: string;
	sortOrder: number;
	code: string;
	accountClassName: string;
}


